export default __webpack_public_path__ + "static/media/MyProfileActiveIcon.c2a23175.svg";